import React from "react";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";

import photo from "./icon-camera.svg";
import video from "./icon-video.svg";
import "./render-story-icon.m.css";

function RenderStoryIcon({ storyTemplate, iconSize }) {
  return (
    <React.Fragment>
      {storyTemplate === "photo" && (
        <span styleName={`media-icon ${iconSize}`}>
          <img src={`${assetify(photo)}`} alt="photo story" />
        </span>
      )}
      {storyTemplate === "video" && (
        <span styleName={`media-icon ${iconSize}`}>
          <img src={`${assetify(video)}`} alt="video story" />
        </span>
      )}
    </React.Fragment>
  );
}
export { RenderStoryIcon };
RenderStoryIcon.propTypes = {
  storyTemplate: PropTypes.string,
  iconSize: PropTypes.string
};
